import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-confirm-deactivate-user-dialog',
  template: `
    <mat-dialog-content>
      <p class="py-6 text-center">
        Please confirm if you'd like to remove
        <span class="font-semibold underline">{{ data.Name }}</span
        >.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="flex w-full justify-center gap-2">
        <button
          class="flex items-center rounded-xl bg-gray-100 px-4 py-2 shadow-sm hover:bg-gray-300"
          [mat-dialog-close]="false"
        >
          Cancel
        </button>
        <button
          class="flex items-center rounded-xl bg-orange-600 px-4 py-2 text-white shadow-sm hover:bg-orange-500"
          (click)="onConfirm()"
          cdkFocusInitial
        >
          Confirm
        </button>
      </div>
    </mat-dialog-actions>
  `,
  imports: [MatDialogModule, MatButtonModule],
})
export class ConfirmDeactivateUserDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeactivateUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: Partial<User>,
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
